
export class PersonSummary {
constructor(
      public id?: number,
      public programCd?: string,
      public enrollmentStartDt?: any,
      public enrollmentEndDt?: any,
      public etRegInd?: any,
      public referredDt?: any,
      public orientationDt?: any,
      public appointmentType?: string,
      public appointmentDt?: any,
      public assessmentDt?: any,
      public activityProgressPercentage?: string,
      public workHoursProgressPercentage?: any,
      public empSvcsCaseMngr?: any,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/person-summary.model.ts